import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const VarietyPackLite = () => (
  <div>
    <h2>Variety Pack Lite</h2>
    <p>8 Channels of Premium Variety Pack Lite Content in HD. $4</p>
    <Button outline color="success" id="varietypacklitetoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#varietypacklitetoggle">
      <Card>
        <CardBody>
          126 - UP<br />
          205 - Turner Classic Movies<br />
          211 - HD NET Movies<br />
          213 - MGM<br />
          214 - IndiePlex<br />
          215 - RetroPlex<br />
          216 - Sony Movie Channel<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default VarietyPackLite;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/varietypacklite.js